let resetting = false;
const reasons = new Set(['confirmed-transfer', 'server-access-change', 'other-tab-transfer']);

// UNION_SESSION_REBOOT_REQUIRED: changing tenant/permissions is an authentication
// boundary, not a data refresh. A fresh document drops every old-tenant module
// cache, pending request and socket, including stores keyed by season number.
export function resetUnionSession(reason, userId = '') {
  if (!reasons.has(reason) || resetting || typeof window === 'undefined') return;
  resetting = true;
  if (reason === 'confirmed-transfer' && userId) {
    try { window.localStorage.setItem(`dororaid:union-transfer:${userId}`, String(Date.now())); } catch { /* Storage disabled. */ }
  }
  window.location.reload();
}
